(function() {
  'use strict';

  function getGallery() {
    return document.querySelector('.custom-product-gallery');
  }

  function showSlideByMediaId(mediaId) {
    const gallery = getGallery();
    if (!gallery) return;
    const slides = gallery.querySelectorAll('.gallery-slide');
    const thumbs = gallery.querySelectorAll('.gallery-thumb');
    const dots = gallery.querySelectorAll('.gallery-dot');
    const slidesContainer = gallery.querySelector('.gallery-slides');
    const isMobile = window.innerWidth < 750;

    let targetIndex = -1;
    slides.forEach((slide, i) => {
      if (targetIndex !== -1) return;
      const img = slide.querySelector('img');
      if (img && String(img.dataset.mediaId) === String(mediaId)) targetIndex = i;
    });
    if (targetIndex === -1) return;

    if (isMobile && slidesContainer) {
      slides[targetIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      dots.forEach((dot, i) => dot.classList.toggle('active', i === targetIndex));
    } else {
      slides.forEach((slide, i) => {
        slide.classList.remove('active');
        slide.style.display = i === targetIndex ? 'block' : 'none';
        slide.style.opacity = i === targetIndex ? '1' : '0';
        slide.style.position = i === targetIndex ? 'relative' : '';
        slide.style.zIndex = i === targetIndex ? '1' : '';
      });
      thumbs.forEach((thumb, i) => thumb.classList.toggle('active', i === targetIndex));
      dots.forEach((dot, i) => dot.classList.toggle('active', i === targetIndex));
      if (slides[targetIndex]) slides[targetIndex].classList.add('active');
      if (thumbs[targetIndex]) thumbs[targetIndex].classList.add('active');
      if (dots[targetIndex]) dots[targetIndex].classList.add('active');
    }
  }

  (function registerVariantListener() {
    document.addEventListener('change', (e) => {
      if (!e.target.matches('input[type="radio"]')) return;
      if (!e.target.closest('.product-form__input')) return;

      setTimeout(() => {
        const productForm = e.target.closest('product-form') || e.target.closest('form[action*="/cart/add"]');
        const variantDataEl = productForm
          ? productForm.querySelector('script[data-selected-variant]')
          : document.querySelector('script[data-selected-variant]');

        if (!variantDataEl) {
          console.log('[v] no variant data element found');
          return;
        }
        try {
          const variant = JSON.parse(variantDataEl.textContent);
          if (!variant || !variant.featured_media) {
            console.log('[v] variant has no featured_media:', variant?.title);
            return;
          }
          console.log('[v] matched variant:', variant.title, 'media:', variant.featured_media.id);
          showSlideByMediaId(variant.featured_media.id);
        } catch(err) {
          console.error('Variant parse error', err);
        }
      }, 300);
    });
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }

  function initGallery() {
    const gallery = document.querySelector('.custom-product-gallery');
    if (!gallery) return;

    const dots = gallery.querySelectorAll('.gallery-dot');
    const slides = gallery.querySelectorAll('.gallery-slide');
    const prevBtn = gallery.querySelector('.gallery-prev');
    const nextBtn = gallery.querySelector('.gallery-next');
    const thumbs = gallery.querySelectorAll('.gallery-thumb');
    const slidesContainer = gallery.querySelector('.gallery-slides');

    const lightbox = document.querySelector('[data-lightbox]');
    const lightboxImage = document.querySelector('.lightbox-image');
    const lightboxClose = document.querySelector('.lightbox-close');
    const lightboxPrev = document.querySelector('.lightbox-prev');
    const lightboxNext = document.querySelector('.lightbox-next');
    const lightboxThumbsContainer = document.querySelector('[data-lightbox-thumbs]');
    const lightboxImageWrapper = document.querySelector('.lightbox-image-wrapper');

    let currentIndex = 0;
    let isTransitioning = false;
    let isZoomed = false;
    let translateX = 0;
    let translateY = 0;
    let lightboxOpenedAt = 0;
    const zoomScale = 2.0;
    const isMobile = window.innerWidth < 750;

    // --- SLIDE FUNCTIONS ---

    function showSlide(index) {
      if (slides.length === 0) return;
      const totalSlides = slides.length;
      index = ((index % totalSlides) + totalSlides) % totalSlides;

      if (isMobile && slidesContainer) {
        slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      } else {
        slides.forEach(slide => {
          slide.classList.remove('active');
          slide.style.display = '';
          slide.style.opacity = '';
          slide.style.pointerEvents = '';
        });
        thumbs.forEach(thumb => thumb.classList.remove('active'));
        if (slides[index]) slides[index].classList.add('active');
        if (thumbs[index]) {
          thumbs[index].classList.add('active');
          thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        dots.forEach(dot => dot.classList.remove('active'));
        if (dots[index]) dots[index].classList.add('active');
      }
      currentIndex = index;
    }

    function nextSlide() {
      if (isTransitioning) return;
      isTransitioning = true;
      showSlide(currentIndex + 1);
      setTimeout(() => { isTransitioning = false; }, 350);
    }

    function prevSlide() {
      if (isTransitioning) return;
      isTransitioning = true;
      showSlide(currentIndex - 1);
      setTimeout(() => { isTransitioning = false; }, 350);
    }

    if (prevBtn) prevBtn.addEventListener('click', (e) => { e.preventDefault(); prevSlide(); });
    if (nextBtn) nextBtn.addEventListener('click', (e) => { e.preventDefault(); nextSlide(); });

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', (e) => { e.preventDefault(); showSlide(index); });
    });
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => showSlide(index));
    });

    if (slidesContainer && isMobile) {
      // Sync dots/thumbs with scroll position using IntersectionObserver
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = Array.from(slides).indexOf(entry.target);
            if (index === -1) return;
            dots.forEach(dot => dot.classList.remove('active'));
            if (dots[index]) dots[index].classList.add('active');
            currentIndex = index;
          }
        });
      }, {
        root: slidesContainer,
        threshold: 0.6
      });
      slides.forEach(slide => observer.observe(slide));
    }

    // --- LIGHTBOX FUNCTIONS ---

    function resetZoom() {
      isZoomed = false;
      translateX = 0;
      translateY = 0;
      if (lightboxImage) {
        lightboxImage.classList.remove('zoomed');
        lightboxImage.style.transform = '';
        lightboxImage.style.transformOrigin = '';
      }
      if (lightboxImageWrapper) {
        lightboxImageWrapper.classList.remove('zoomed');
        if (!isMobile) lightboxImageWrapper.style.cursor = 'zoom-in';
      }
    }

  function openLightbox(index) {
    if (!lightbox || !lightboxImage) return;
    resetZoom();

    if (isMobile) {
      // Build scroll-snap slides inside lightbox-image-wrapper
      lightboxImageWrapper.innerHTML = '';
      slides.forEach((slide, i) => {
        const img = slide.querySelector('img');
        if (!img) return;
        const slideEl = document.createElement('div');
        slideEl.classList.add('lightbox-slide');
        const imgEl = document.createElement('img');
        imgEl.src = img.src;
        imgEl.alt = img.alt;
        slideEl.appendChild(imgEl);
        lightboxImageWrapper.appendChild(slideEl);
      });

      // Sync lightbox thumbs
      if (lightboxThumbsContainer) {
        lightboxThumbsContainer.innerHTML = '';
        thumbs.forEach((thumb, i) => {
          const clone = thumb.cloneNode(true);
          clone.classList.remove('gallery-thumb');
          clone.classList.add('lightbox-thumb');
          if (i === index) clone.classList.add('active');
          clone.addEventListener('click', () => {
            const lightboxSlides = lightboxImageWrapper.querySelectorAll('.lightbox-slide');
            if (lightboxSlides[i]) {
              lightboxSlides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }
            lightboxThumbsContainer.querySelectorAll('.lightbox-thumb').forEach((t, j) => {
              t.classList.toggle('active', j === i);
            });
          });
          lightboxThumbsContainer.appendChild(clone);
        });
      }

      // Scroll to the tapped slide
      lightboxOpenedAt = Date.now();
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
      currentIndex = index;

      requestAnimationFrame(() => {
        const lightboxSlides = lightboxImageWrapper.querySelectorAll('.lightbox-slide');
        if (lightboxSlides[index]) {
          lightboxSlides[index].scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
        }
      });

      // Sync dots/thumbs on scroll
      const lightboxObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const lightboxSlides = lightboxImageWrapper.querySelectorAll('.lightbox-slide');
            const i = Array.from(lightboxSlides).indexOf(entry.target);
            if (i === -1) return;
            lightboxThumbsContainer?.querySelectorAll('.lightbox-thumb').forEach((t, j) => {
              t.classList.toggle('active', j === i);
            });
            currentIndex = i;
          }
        });
      }, { root: lightboxImageWrapper, threshold: 0.6 });

      lightboxImageWrapper.querySelectorAll('.lightbox-slide').forEach(s => lightboxObserver.observe(s));

    } else {
      // Desktop: existing behavior
      const img = slides[index].querySelector('img');
      if (!img) return;
      lightboxImage.src = img.src;
      lightboxImage.alt = img.alt;
      if (lightboxThumbsContainer) {
        lightboxThumbsContainer.innerHTML = '';
        thumbs.forEach((thumb, i) => {
          const clone = thumb.cloneNode(true);
          clone.classList.remove('gallery-thumb');
          clone.classList.add('lightbox-thumb');
          if (i === index) clone.classList.add('active');
          clone.addEventListener('click', () => updateLightboxImage(i));
          lightboxThumbsContainer.appendChild(clone);
        });
      }
      lightboxOpenedAt = Date.now();
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
      currentIndex = index;
    }
  }

    /*
    function openLightbox(index) {
      if (!lightbox || !lightboxImage) return;
      const img = slides[index].querySelector('img');
      if (!img) return;
      resetZoom();
      lightboxImage.src = img.src;
      lightboxImage.alt = img.alt;
      if (lightboxThumbsContainer) {
        lightboxThumbsContainer.innerHTML = '';
        thumbs.forEach((thumb, i) => {
          const clone = thumb.cloneNode(true);
          clone.classList.remove('gallery-thumb');
          clone.classList.add('lightbox-thumb');
          if (i === index) clone.classList.add('active');
          clone.addEventListener('click', () => updateLightboxImage(i));
          lightboxThumbsContainer.appendChild(clone);
        });
      }
      lightboxOpenedAt = Date.now();
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
      currentIndex = index;
    } */

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
      resetZoom();
    }

    function updateLightboxImage(index) {
      const totalSlides = slides.length;
      index = ((index % totalSlides) + totalSlides) % totalSlides;
      const img = slides[index].querySelector('img');
      if (lightboxImage && img) {
        resetZoom();
        lightboxImage.src = img.src;
        lightboxImage.alt = img.alt;
      }
      if (lightboxThumbsContainer) {
        const lightboxThumbs = lightboxThumbsContainer.querySelectorAll('.lightbox-thumb');
        lightboxThumbs.forEach(thumb => thumb.classList.remove('active'));
        if (lightboxThumbs[index]) {
          lightboxThumbs[index].classList.add('active');
          lightboxThumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
      currentIndex = index;
    }

    if (lightboxClose) lightboxClose.addEventListener('click', (e) => { e.preventDefault(); closeLightbox(); });
    if (lightboxPrev) lightboxPrev.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); updateLightboxImage(currentIndex - 1); });
    if (lightboxNext) lightboxNext.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); updateLightboxImage(currentIndex + 1); });

    if (lightbox) {
      lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
    }

    // --- DESKTOP ZOOM ---

    if (!isMobile && lightboxImage && lightboxImageWrapper) {
      let isPanning = false;
      let hasDragged = false;
      let startX, startY;
      let startTranslateX = 0, startTranslateY = 0;

      function applyTransform() {
        lightboxImage.style.transform = `scale(${zoomScale}) translate(${translateX}px, ${translateY}px)`;
      }

      lightboxImageWrapper.addEventListener('mousedown', (e) => {
        if (!isZoomed) return;
        isPanning = true;
        hasDragged = false;
        startX = e.clientX;
        startY = e.clientY;
        startTranslateX = translateX;
        startTranslateY = translateY;
        lightboxImageWrapper.style.cursor = 'grabbing';
        e.preventDefault();
      });

      window.addEventListener('mousemove', (e) => {
        if (!isPanning || !isZoomed) return;
        const dx = (e.clientX - startX) / zoomScale;
        const dy = (e.clientY - startY) / zoomScale;
        if (Math.abs(dx) > 2 || Math.abs(dy) > 2) hasDragged = true;
        translateX = startTranslateX + dx;
        translateY = startTranslateY + dy;
        applyTransform();
      });

      window.addEventListener('mouseup', () => {
        isPanning = false;
        if (isZoomed) lightboxImageWrapper.style.cursor = 'grab';
      });

      lightboxImageWrapper.addEventListener('click', (e) => {
        if (Date.now() - lightboxOpenedAt < 100) return;
        if (hasDragged) { hasDragged = false; return; }
        e.stopPropagation();
        if (!isZoomed) {
          translateX = 0;
          translateY = 0;
          lightboxImage.classList.add('zoomed');
          lightboxImageWrapper.classList.add('zoomed');
          lightboxImage.style.transformOrigin = 'center center';
          applyTransform();
          lightboxImageWrapper.style.cursor = 'grab';
          isZoomed = true;
        } else {
          resetZoom();
        }
      });

      lightboxImageWrapper.style.cursor = 'zoom-in';
    }

    // --- KEYBOARD ---

    document.addEventListener('keydown', (e) => {
      if (!lightbox || !lightbox.classList.contains('active')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') updateLightboxImage(currentIndex - 1);
      if (e.key === 'ArrowRight') updateLightboxImage(currentIndex + 1);
    });

    // --- SLIDE CLICK TO OPEN LIGHTBOX ---

    slides.forEach((slide, index) => {
      slide.style.cursor = 'pointer';
      slide.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!e.target.closest('.gallery-prev') && !e.target.closest('.gallery-next')) {
          openLightbox(index);
        }
      });
    });

    // Start on the slide already marked active in Liquid
    const activeSlide = gallery.querySelector('.gallery-slide.active');
    const activeIndex = activeSlide ? Array.from(slides).indexOf(activeSlide) : 0;
    showSlide(activeIndex >= 0 ? activeIndex : 0);
  }

})();